import { ProductTokens } from '../types'
import { colors } from './colors'
import type { SevenNewsPalette } from './colors'

export const sevennews: ProductTokens<SevenNewsPalette> = {
    colors,
}
